import React, { ChangeEvent, useCallback } from "react";
import { HouseIdPrefixList } from "../../../../../domain/care_recipient/CareRecipientHouseId";



export const CareRecipientFilterComponent = React.memo(function CareRecipientFilterComponent(props: CareRecipientFilterComponentProps) {
    const {
        houseIdPrefixFilters,
        handleHouseIdPrefixFilters,
    } = props;

    const isMatchedFilter = useCallback((houseIdPrefix: string) => houseIdPrefixFilters.includes(houseIdPrefix), [houseIdPrefixFilters]);

    const handleFilterChanged = useCallback((e: ChangeEvent<HTMLInputElement>) => handleHouseIdPrefixFilters(e.target.value), [handleHouseIdPrefixFilters]);

    return (
        <div className="filter">
            {HouseIdPrefixList.map((it) => (
                <label className="check_box" key={it}>
                    <input type="checkbox" value={it} checked={isMatchedFilter(it)} onChange={handleFilterChanged} />
                    <span className="icon_checked" />
                    {it}
                </label>
            ))}
        </div>
    );
});

export type CareRecipientFilterComponentProps = {
    houseIdPrefixFilters: string[],
    handleHouseIdPrefixFilters: (houseIdPrefix: string) => void,
};